import {
    Customer,
    CustomerAccount,
    UpdateCustomer,
    UpdateCustomerAccount,
    UpdateCustomerAgreement,
} from '../models/Customer';
import ApisClient from '../utils/client/ApisClient';

export const getCustomerData = () => {
    return ApisClient.get<Customer>('/customer/data');
};

export const getCustomerAccounts = () => {
    return ApisClient.get<CustomerAccount[]>('/customer/accounts');
};

export const updateCustomerData = (data: UpdateCustomer) => {
    return ApisClient.post('/customer/data/update', data);
};

export const updateCustomerAccounts = (data: UpdateCustomerAccount) => {
    return ApisClient.post('/customer/accounts/update', data);
};

export const updateCustomerAgreement = (contactSessionId: string, accepted: boolean) => {
    const data: UpdateCustomerAgreement = {
        contactSessionId: contactSessionId,
        updateAgreement: [
            {
                code: 'C125',
                accepted: accepted,
            },
        ],
    };
    return ApisClient.post('/customer/agreement/update', data);
};

export const sendContactVerificationOTP = (contact: string) => {
    return ApisClient.post('/customer/contact/verify/otp/send', { contact: contact });
};

export const validateContactVerificationOTP = (otp: string) => {
    return ApisClient.post('/customer/contact/verify/otp/validate', { otp: otp });
};

export const updateCustomerPassword = (newPassword: string) => {
    return ApisClient.post('/customer/password/update', { newPassword: newPassword });
};
